import themeColors, { themeFonts, themeFontsSize } from "@GeriMed/styles/variables";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    logoGridItem: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            img {
                height: 78px;
            }
        `,
    },
    linkList1GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList2GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList3GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: 12,
        css: css`
            padding: 0;
        `,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },
    logoWrapper: {
        css: css`
            width: 110px;
        `,
    },
    widgetGridContainer: {
        gap: 0,
        css: css`
            max-width: 100% !important;

            .top-section,
            .bottom-section {
                width: 100%;
                max-width: 100% !important;
                [class*="GridOffset"] {
                    max-width: 82.5em;
                    margin: 0 auto;
                    padding-top: 26px;
                    color: ${themeColors.colorWhite};
                }

                .wrapper {
                    p {
                        margin-bottom: 6px;
                        line-height: ${themeFontsSize.size15};
                        font-size: ${themeFontsSize.size1225};
                        font-family: ${themeFonts.fontFamilyLexendDeca};
                    }
                    padding: 0 15px;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                            margin-bottom: 10px;
                            padding: 0 20px;
                            `,
                        ],
                        "max",
                    )}
                }
            }
            .footer-top-nav {
                & > [class*="GridOffset"]:first-child {
                    border-bottom: 2px solid #acadb8;                   
                    @media screen and (max-width: 1024px) {
                        border: 0;                      
                        padding: 0 2px !important; 
                    }
                }
            }

            .custom-line {
                padding: 0 !important;
                border: 0;
                 @media screen and (max-width: 1024px) {
                    border-top: 2px solid #acadb8;
                }
            }
           

            .top-section {
                background: ${themeColors.lightRedColor};
                border-top: 1px solid #d7d7d7;
                padding: 0 0 50px 0;

                @media (min-width: 640px) and (max-width: 767px) {
                    padding: 16px 10px 50px 10px;
                    > [class*="GridOffset"] {
                        display: grid;
                        grid-template-columns: 60% 40%;
                    }
                }
            }

            .bottom-section {
                padding-bottom: 0;
                background: ${themeColors.drakBlue};
            }
            .bottom-section-sepration{
                padding: 0 15px;
            }
            @media (min-width: 1024px){
                .bottom-section.bottom-copyright {
                    padding-bottom: 26px;
                }
            }

            footer > [class*="GridWrapper"] {
                max-width: 100%;
            }
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer className="footer-container" {...styles.widgetGridContainer}>
            <GridItem {...styles.socialLinksGridItem}>
                <Zone zoneName="SocialLinks" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;